import moment from 'moment';

export const addHour = (time, hour) => {
  const newTime = moment(time).add(hour, 'hour');
  const endOfDay = moment(time).endOf('day');
  return (newTime.isAfter(endOfDay) ? endOfDay : newTime);
};
